import update from 'immutability-helper';
import SelfServeBuilderEnum from 'SelfServeBuilder/SelfServeBuilderConstants';
import PopupGroupConstants from './PopupGroupConstants';

function removePopupGroupIdFromPage(state, pageIndex, popupGroupIndex) {
  if (!state.popupGroupsOnPage[pageIndex]) {
    return state;
  }
  if (state.popupGroupsOnPage[pageIndex].length > 1) {
    return update(state, {
      popupGroupsOnPage: {
        [pageIndex]: {
          $splice: [[popupGroupIndex, 1]],
        },
      },
    });
  }
  return update(state, {
    popupGroupsOnPage: { $unset: [pageIndex] },
  });
}

function addPopupGroupIdToPage(state, pageIndex, groupId) {
  if (!state.popupGroupsOnPage[pageIndex]) {
    return update(state, {
      popupGroupsOnPage: {
        [pageIndex]: {
          $set: [groupId],
        },
      },
    });
  }
  return update(state, {
    popupGroupsOnPage: {
      [pageIndex]: {
        $push: [groupId],
      },
    },
  });
}

const initialState = {
  activeGroupId: null,
  /* Example of popupGroups Structure
    'group-popup-id': {
      label: 'This is the group question',
      fieldIds: ['checkbox-id'],
      type: 'checkbox',
      pageIndex: 0,
    }
  */
  popupGroups: {},
  isEditingGroup: false,
  popupGroupsOnPage: {}, // {pageId: [array of popup group ids]}
};

const PopupGroupReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  let pageIndex;
  let updatedState;
  switch (action.type) {
    case SelfServeBuilderEnum.SELF_SERVE_BUILDER_CUSTOM_TEMPLATE_DATA_GET_SUCCESS: {
      const popupGroupsOnPage = action.data.custom_template.field_outline.popupGroupsOnPage;

      updatedState = update(state, {
        popupGroups: { $set: action.data.custom_template.field_outline.fieldGroups || {} },
        activeGroupId: { $set: action.data.custom_template.field_outline.activeGroupId || null },
        isEditingGroup: { $set: !!action.data.custom_template.field_outline.activeGroupId },
        popupGroupsOnPage: { $set: popupGroupsOnPage || {} },
      });
      break;
    }
    case PopupGroupConstants.POPUP_GROUP_CREATE:
      pageIndex = action.data.pageIndex;

      updatedState = update(state, {
        popupGroups: {
          [action.groupId]: {
            $set: action.data,
          },
        },
        activeGroupId: { $set: action.groupId },
        isEditingGroup: { $set: true },
      });
      updatedState = addPopupGroupIdToPage(updatedState, pageIndex, action.groupId);
      break;
    case PopupGroupConstants.POPUP_GROUP_POPUP_ADD:
      updatedState = update(state, {
        popupGroups: {
          [action.groupId]: {
            fieldIds: { $push: [action.id] },
          },
        },
      });
      break;
    case PopupGroupConstants.POPUP_GROUP_ACTIVE_CLEAR:
      updatedState = update(state, {
        activeGroupId: { $set: null },
        isEditingGroup: { $set: false },
      });
      break;
    case PopupGroupConstants.POPUP_GROUP_ACTIVE_SET:
      updatedState = update(state, {
        activeGroupId: { $set: action.groupId },
        isEditingGroup: { $set: true },
      });
      break;
    case PopupGroupConstants.POPUP_GROUP_EDIT_GROUP_START:
      updatedState = update(state, {
        isEditingGroup: { $set: true },
      });
      break;
    case PopupGroupConstants.POPUP_GROUP_EDIT_GROUP_END:
      updatedState = update(state, {
        isEditingGroup: { $set: false },
      });
      break;
    case PopupGroupConstants.POPUP_GROUP_POPUP_REMOVE: {
      pageIndex = state.popupGroups[action.groupId].pageIndex;
      const popupIndex = state.popupGroups[action.groupId].fieldIds.indexOf(action.popupId);
      const pagePopupGroupIndex = state.popupGroupsOnPage[pageIndex].indexOf(action.groupId);
      if (state.popupGroups[action.groupId].fieldIds.length <= 1) {
        updatedState = update(state, {
          popupGroups: { $unset: [action.groupId] },
          activeGroupId: { $set: null },
          isEditingGroup: { $set: false },
        });
        updatedState = removePopupGroupIdFromPage(updatedState, pageIndex, pagePopupGroupIndex);
      } else {
        updatedState = update(state, {
          popupGroups: {
            [action.groupId]: {
              fieldIds: { $splice: [[popupIndex, 1]] },
            },
          },
        });
      }
      break;
    }
    case PopupGroupConstants.POPUP_GROUP_QUESTION_UPDATE:
      updatedState = update(state, {
        popupGroups: {
          [action.groupId]: {
            label: { $set: action.question },
          },
        },
      });
      break;
    default: {
      updatedState = state;
      break;
    }
  }
  return updatedState;
};

export default PopupGroupReducer;



// WEBPACK FOOTER //
// ./src-react/PopupGroup/PopupGroupReducer.jsx